module.exports = __webpack_public_path__ + "img/categorie-huitres-plates-famille-boutrais.a27925d8.webp";